namespace Matrix.Rebalancer {
    export namespace TradeMacroAssignmentService {
        export const baseUrl = 'Rebalancer/TradeMacroAssignment';

        export declare function Create(request: Serenity.SaveRequest<TradeMacroAssignmentRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TradeMacroAssignmentRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TradeMacroAssignmentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TradeMacroAssignmentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/TradeMacroAssignment/Create",
            Update = "Rebalancer/TradeMacroAssignment/Update",
            Delete = "Rebalancer/TradeMacroAssignment/Delete",
            Retrieve = "Rebalancer/TradeMacroAssignment/Retrieve",
            List = "Rebalancer/TradeMacroAssignment/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>TradeMacroAssignmentService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
